// value widgets
import BootstrapTextWidget from "./value/BootstrapText";
import BootstrapTextAreaWidget from "./value/BootstrapTextArea";
import BootstrapDateWidget from "./value/BootstrapDate";
import BootstrapDateTimeWidget from "./value/BootstrapDateTime";
import BootstrapTimeWidget from "./value/BootstrapTime";
import BootstrapSelectWidget from "./value/BootstrapSelect";
import BootstrapNumberWidget from "./value/BootstrapNumber";
import BootstrapSliderWidget from "./value/BootstrapSlider";
import BootstrapBooleanWidget from "./value/BootstrapBoolean";
import BootstrapMultiSelectWidget from "./value/BootstrapMultiSelect";

// field select widgets
import BootstrapFieldSelect from "./core/BootstrapFieldSelect";

// core components
import BootstrapButton from "./core/BootstrapButton";
import BootstrapButtonGroup from "./core/BootstrapButtonGroup";
import BootstrapConjs from "./core/BootstrapConjs";
import BootstrapValueSources from "./core/BootstrapValueSources";
import BootstrapConfirm from "./core/BootstrapConfirm";

// provider
var BootstrapProvider = function BootstrapProvider(_ref) {
  var config = _ref.config,
    children = _ref.children;
  return children;
};
export default {
  BootstrapTextWidget: BootstrapTextWidget,
  BootstrapTextAreaWidget: BootstrapTextAreaWidget,
  BootstrapDateWidget: BootstrapDateWidget,
  BootstrapDateTimeWidget: BootstrapDateTimeWidget,
  BootstrapTimeWidget: BootstrapTimeWidget,
  BootstrapSelectWidget: BootstrapSelectWidget,
  BootstrapNumberWidget: BootstrapNumberWidget,
  BootstrapSliderWidget: BootstrapSliderWidget,
  BootstrapBooleanWidget: BootstrapBooleanWidget,
  BootstrapMultiSelectWidget: BootstrapMultiSelectWidget,
  BootstrapFieldSelect: BootstrapFieldSelect,
  BootstrapButton: BootstrapButton,
  BootstrapButtonGroup: BootstrapButtonGroup,
  BootstrapConjs: BootstrapConjs,
  BootstrapValueSources: BootstrapValueSources,
  BootstrapConfirm: BootstrapConfirm,
  BootstrapProvider: BootstrapProvider
};